/**
 * Generic Highlighting Utilities
 *
 * Reusable utilities for rendering highlighted text with consistent styling
 * across different domains (business, magazine, company, etc.).
 */

/**
 * Generic utility function to render highlighted titles
 * @param {Object} config - Configuration object with prefix, highlight, and suffix
 * @param {string} innovationTextClasses - CSS classes for the highlighted span
 * @param {string} fallback - Optional fallback text if config is not found
 * @returns {JSX.Element|string|null} - The rendered highlighted title or fallback
 */
export const renderHighlightedTitle = (
  config,
  innovationTextClasses,
  fallback = null,
) => {
  if (!config) return fallback;

  return (
    <>
      {config.prefix && `${config.prefix} `}
      <span className={innovationTextClasses}>{config.highlight}</span>
      {config.suffix && ` ${config.suffix}`}
    </>
  );
};

/**
 * Utility function to render highlighted titles from a configuration map
 * @param {Object} configMap - Map of configurations (e.g., BUSINESS_PAGE_HIGHLIGHTS)
 * @param {string} key - Key to lookup in the configuration map
 * @param {string} innovationTextClasses - CSS classes for the highlighted span
 * @param {string} fallback - Optional fallback text if key is not found
 * @returns {JSX.Element|string|null} - The rendered highlighted title or fallback
 */
export const renderHighlightedTitleFromMap = (
  configMap,
  key,
  innovationTextClasses,
  fallback = null,
) => {
  const config = configMap[key];
  return renderHighlightedTitle(config, innovationTextClasses, fallback);
};

export default renderHighlightedTitle;
